<template>
<v-app>
    <v-container>
  <div class="feedback">


    

    

    <v-card max-width="800" class="mx-auto auth">
        <template v-if="success">
                    <v-card-title  class="headline">Спасибо!</v-card-title>
                    <v-card-text>
                        Ваша вопрос успешно отправлен, теперь Вы можете <a href="/">вернуться к работе</a></a>

                    </v-card-text>
                    
        </template>
        <template v-else>
            <div style="text-align: center;">
                <img src="/logo-alians.jpg">
            </div>
            <!--
            <h1>
                Рады сообщить,<br>
                <small>что ассоциация «АннА» является партнером «Альянса фармацевтических ассоциаций»</small>
            </h1>
            -->
            <v-card-text>

     
                
                    <p><b>Ассоциация «АннА» является партнером «Альянса фармацевтических ассоциаций»</b>, который принимает активное участие в создании продуманной государственной политики в сфере фармацевтики и медицины с помощью конструктивного диалога с представителями законодательных и исполнительных органов власти.</p>
                    <p>Подробнее с деятельностью альянса можно ознакомиться <a href="https://cro.asna.ru/about/intelligence/" target="_blank">по ссылке</a></p>
                        
                    <p>Здесь вы можете оставить свои вопросы, предложения и пожелания. Вся информация будет передана Альянсу.</p>

                    <p style="text-align: center;"><b>Давайте вместе работать на благо нашей отрасли!</b></p>
                
                

                
                <v-textarea 
                            label="Ваши предложения" v-model="question"
                            :error-messages="error.question" 
                />
                <v-checkbox 
                    label="согласие на обработку персональных данных"
                    v-model="igree"
                />
                <div class="err" v-if="error.length">
                        <div v-for="(e,idx) in error" :key="'err'+idx" v-html="e"></div>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn color="primary" ref="button" :disabled="submit_disabled" @click="submit()" small>Отправить</v-btn>
            </v-card-actions>
        </template>
    </v-card>
</div>
</v-container>
</v-app>
</template>

<script>
let t
export default {
        props:['params','is_headapp'],
        data(){
          return {
            
            success: false,
            igree:false,
            question: '',
            error:{
                question:''
            }
          }
        },

        mounted () {
          t=this
         
        },

        created(){
          
        },
        watch:{
            question(){
                this.error.question=''
            }
        },
        methods: {
          check(){
            if(!this.question)
                this.error.question='Введите вопрос'
          },

          submit(){
            this.check()
            if(this.submit_disabled)
                return 
            
            this.$http.post(
              BackendBase+'/anna/feedback',
              {
                  question: this.question,
              }
            ).then(
              response=>{
                let D=response.data;
                if(D.success)
                  this.success=true
                
                this.error=D.errors
                
              }
            )                
          }
        },
        computed:{
            submit_disabled(){
                return (this.question.length < 10) || !this.igree
            }
        }


        
        
}
</script>
<style scoped>
  h1 {margin-bottom: 20px; text-align: center; display: inline-block;}
  .logo {
    position: relative;  width: 170px; 
    background-color: rgb(212, 212, 212);

    display: inline-block;
  }
  .feedback {margin: 20px;}
  .auth .err{ color: red; background-color: white;}
  .is_headapp{ margin: 20px; max-width: 800px;}
  .sort_asc, .sort_desc {text-decoration: none !important;}
  .links {margin-left: 20px; border-bottom: 1px dotted black; padding-bottom: 20px;}
  
</style>



